import { gql } from 'apollo-boost';

export const UPDATE_BUSINESS_GROUP_GQL = gql`
  mutation BusinessGroupUpdate($id: ID!, $name: String!) {
    business_group_update(input: { id: $id, name: $name }) {
      business_group {
        id
        name
        created_at
        updated_at
        businesses {
          id
          name
        }
      }
    }
  }
`;
